import { render, staticRenderFns } from "./RememberPasswordPage.vue?vue&type=template&id=53531865&scoped=true"
import script from "./RememberPasswordPage.js?vue&type=script&lang=js&external"
export * from "./RememberPasswordPage.js?vue&type=script&lang=js&external"
import style0 from "./RememberPasswordPage.vue?vue&type=style&index=0&id=53531865&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53531865",
  null
  
)

export default component.exports